export const dataConstants = {
	insuranceCoverageTypes: {
		cashPay: 'CASH_PAY',
		outOfNetwork: 'INSURED_OUT_OF_NETWORK',
		inNetworkWithCopay: 'INSURED_IN_NETWORK_WITH_COPAY',
		inNetworkNoCopay: 'INSURED_IN_NETWORK_NO_COPAY',
	},
	appointmentTypes: {
		initial: 'INITIAL_CLINICAL_VISIT',
		subsequent: 'SUBSEQUENT_CLINICAL_VISIT',
		initialMedication: 'MH_MEDICATION_INITIAL',
		subsequentMedication: 'MH_MEDICATION_FOLLOWUP',
		initialTherapy: 'MH_THERAPY_INITIAL',
		therapy: 'MH_THERAPY_FOLLOWUP',
	},
};

export const testContent = {};
